import { canUseDOM } from 'exenv';
import set from 'lodash/set';
import asyncInnovationByDesignPageAction from '../../../../../redux/actions/ibd/async_innovation_by_design_page_actions';
import log from '../../../../../services/logger_service';

export default function fetchDataWithStore(store, override) {
  return function fetchData(nextState, replace, callback) {
    const { dispatch } = store;

    if (override) {
      set(nextState, 'params.year', override);
    }

    // console.log("Params ", params.year);

    // run async
    if (canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      asyncInnovationByDesignPageAction(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return asyncInnovationByDesignPageAction(nextState.params, store)(dispatch)
      .then(function cb() {
        if (callback) {
          return callback();
        }
        return false;
      })
      .catch(function handleActionError(error) {
        log.fatal(
          error,
          `Fatal error in onEnter state manager: ${error.message}`
        );
        if (callback) {
          return callback(error);
        }
        return false;
      });
  };
}
